// https://chrome.google.com/webstore/detail/commandbar-editor/diahhhkcbpeijifhedabbjgepdgdpkcj
// NOTE: if doing local development, replace this with your local extension ID from chrome://extensions
export const COMMANDBAR_CHROME_EXTENSION_ID = 'diahhhkcbpeijifhedabbjgepdgdpkcj';
export const COMMANDBAR_CHROME_EXTENSION_URL = `https://chrome.google.com/webstore/detail/commandbar-editor/${COMMANDBAR_CHROME_EXTENSION_ID}`;
